<template>
  <div class="row justify-content-center align-items-center mb-3">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-md-center">
            <div class="col-10">
              <a href="/orders" class="text-success">
                <i class="fas pl-1 fa-chevron-left"></i> Back</a
              >
            </div>
            <h2 class="my-3 font-22 col-10">
              <strong>
                {{ order.id ? `Order # ${order.id}` : "New order" }}
              </strong>
            </h2>

            <div
              class="col-10 d-flex justify-content-between align-items-baseline"
            >
              <div
                v-if="order.id && edit_order"
                :class="countdown ? 'alert-danger' : 'alert-success'"
                class="alert py-2 px-3 rounded-lg"
              >
                <div v-if="countdown">
                  <p class="mb-1 text-danger font-bold">
                    <i class="fal fa-question-circle"></i>
                    <strong>{{ countdown }}</strong> left to amend your order
                  </p>
                  <p class="mb-0 text-danger ml-4">
                    We will be unable to accept amendments to your order after
                    {{ moment(limit_edit_date).format("DD MMM YYYY hh:mm a") }}
                  </p>
                </div>
                <div v-else class="mb-0 text-green-primary">
                  <i class="fal fa-question-circle"></i> You can amend your
                  order up till
                  {{ moment(limit_edit_date).format("DD MMM YYYY hh:mm a") }}
                </div>
              </div>

              <div class="alert alert-info" v-else-if="order.id">
                <i class="fas fa-question-circle"></i>
                We are processing your order. Please contact us to request any
                change this order
              </div>

              <div class="d-flex align-items-center ml-auto">
                <a
                  href=""
                  class="p-2 mr-2 text-green-primary"
                  @click="cancelOrder"
                  ><strong>Cancel</strong></a
                >
                <el-button
                  @click="onSubmit"
                  class="btn-primary-rounded p-3"
                  type="primary"
                  :disabled="!delivery || (!edit_order && order.id)"
                >
                  <i class="far fa-save mr-1"></i>
                  {{ order.id ? "Save changes" : "Save order" }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center align-items-center mb-3">
        <div class="col col-sm-10">
          <div class="account-card card mb-5">
            <div class="">
              <h2 class="">Order Details</h2>
              <hr class="mb-4" />

              <div class="row">
                <div class="form-group col-12 col-md-6">
                  <label for="submitted_at">Order Type</label>
                  <div class="input-group">
                    <el-select
                      filterable
                      size="large"
                      :class="[
                        { 'is-invalid': form.errors.has('order_type_id') },
                        'w-100',
                      ]"
                      v-model="order.order_type_id"
                      @change="
                        form.errors.clear('order_type_id');
                        onOrderTypeChange();
                      "
                    >
                      <el-option
                        v-for="item in orderTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>

                    <div
                      class="invalid-feedback"
                      v-if="form.errors.has('order_type_id')"
                    >
                      Please provide a order type
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="[1, 2].includes(order.order_type_id)">
                <h2 class="mb-4">Delivery Details</h2>
                <div class="row">
                  <div class="form-group col-12 col-md-6">
                    <label for="name">Full Name</label>
                    <div class="input-group">
                      <input
                        type="text"
                        name="name"
                        :class="[
                          {
                            'is-invalid': form.errors.has('site_contact_name'),
                          },
                          'form-control',
                        ]"
                        id="name-input"
                        @keydown="form.errors.clear('site_contact_name')"
                        v-model="order.site_contact_name"
                        placeholder="Name"
                      />
                      <div class="invalid-feedback">Please enter a name.</div>
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-12">
                    <label for="address">Address</label>
                    <div class="input-group">
                      <vue-google-autocomplete
                        id="map"
                        :fields="this.mapFields"
                        class="form-control"
                        placeholder="Start typing"
                        v-on:placechanged="getAddressData"
                        :value="order.address"
                        :country="['au']"
                        types=""
                      >
                      </vue-google-autocomplete>
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-6">
                    <label for="apartment"
                      >Apartment, suite, etc. (optional)</label
                    >
                    <div class="input-group">
                      <input
                        type="text"
                        name="apartment"
                        class="form-control"
                        v-model="order.unit_number"
                        placeholder="Apartment, suite"
                      />
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-6">
                    <label for="city">City</label>
                    <div class="input-group">
                      <input
                        type="text"
                        name="city"
                        class="form-control"
                        disabled
                        v-model="order.suburb"
                        placeholder="City"
                      />
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-6">
                    <label for="state">State</label>
                    <div class="input-group">
                      <input
                        type="text"
                        name="state"
                        class="form-control"
                        disabled
                        v-model="order.state"
                        placeholder="State"
                      />
                    </div>
                  </div>
                  <div class="form-group col-12 col-md-6">
                    <label for="postcode">Delivery postcode</label>
                    <div class="input-group">
                      <input
                        type="text"
                        name="postcode"
                        class="form-control w-100"
                        disabled
                        v-model="order.post_code"
                        placeholder="Delivery Postcode"
                      />
                      <div
                        class="text-danger"
                        v-if="order.post_code && !delivery"
                      >
                        Please
                        <a
                          :href="`${website_url}/pages/contact`"
                          target="_blank"
                          >contact our team</a
                        >
                        to discuss delivery to your area
                      </div>
                      <div
                        class="text-success"
                        v-if="order.post_code && delivery"
                      >
                        We deliver!!
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 col-md-6">
                    <label for="name">Phone Number</label>
                    <div class="input-group">
                      <vue-tel-input
                        @onValidate="onNumberValidate"
                        @onInput="form.errors.clear('site_contact_phone')"
                        :class="[
                          {
                            'is-invalid':
                              form.errors.has('site_contact_phone') ||
                              (!validated && order.site_contact_phone),
                          },
                          'w-100',
                        ]"
                        :onlyCountries="['AU', 'GB', 'NZ', 'US']"
                        v-model="order.site_contact_phone"
                      ></vue-tel-input>
                      <div class="invalid-feedback">
                        Please provide a valid number
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="order.order_type_id">
                <div class="col-12">
                  <h2 class="mb-4">
                    {{ order.order_type_id != 3 ? "Delivery" : "Pickup" }} Date
                  </h2>
                </div>
                <div class="form-group col-12 col-md-6">
                  <label for="name"
                    >{{
                      order.order_type_id != 3 ? "Delivery" : "Pickup"
                    }}
                    Date</label
                  >
                  <div class="input-group">
                    <el-date-picker
                      @change="form.errors.clear('delivery_date')"
                      :class="[
                        { 'is-invalid': form.errors.has('delivery_date') },
                        'w-100',
                      ]"
                      v-model="order.delivery_date"
                      id="delivery_date"
                      type="date"
                      :placeholder="
                        order.order_type_id != 3
                          ? 'Delivery date'
                          : 'Pick up date'
                      "
                      value-format="yyyy-MM-dd HH:mm:00"
                      :picker-options="pickerOptions"
                      format="dd/MM/yyyy"
                    >
                    </el-date-picker>
                    <div class="invalid-feedback">
                      <p>Please enter a date.</p>
                    </div>
                  </div>
                </div>
                <div
                  class="form-group col-12 col-md-6"
                  v-if="order.order_type_id == 3"
                >
                  <label for="delivery_date" class="d-flex">Pickup Time</label>
                  <el-time-picker
                    :class="[
                      { 'is-invalid': form.errors.has('delivery_date') },
                      'w-100',
                    ]"
                    v-model="order.pick_up_at"
                    placeholder="Select time"
                    value-format="HH:mm:ss"
                    format="hh:mm A"
                  >
                  </el-time-picker>
                  <div class="invalid-feedback">
                    Please enter a pickup time.
                  </div>
                </div>
                <div class="form-group col-12 col-md-12">
                  <label for="notes">
                    {{ order.order_type_id != 3 ? "Delivery" : "Pickup" }} Notes
                  </label>
                  <textarea
                    v-model="order.delivery_notes"
                    class="form-control"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit order -->
          <div class="account-card card mb-5">
            <div class="">
              <h2 class="mb-4">Edit Order</h2>
              <div
                :class="[{ 'is-invalid': form.errors.has('items') }, 'w-100']"
              ></div>
              <div class="invalid-feedback" v-if="form.errors.has('items')">
                Items are required.
              </div>
              <hr />
              <div class="row py-2">
                <div class="col-1"></div>
                <div class="col-5">
                  <p>
                    <strong class="text-black-500 text-uppercase font-14"
                      >Turf Type</strong
                    >
                  </p>
                </div>
                <div class="col-2">
                  <p>
                    <strong class="text-black-500 text-uppercase font-14"
                      >Quantity (m2)</strong
                    >
                  </p>
                </div>
                <div class="col-2">
                  <p>
                    <strong class="text-black-500 text-uppercase font-14"
                      >Price(ex GST)</strong
                    >
                  </p>
                </div>
                <div class="col-2">
                  <p>
                    <strong class="text-black-500 text-uppercase font-14"
                      >Action</strong
                    >
                  </p>
                </div>
              </div>

              <div
                class="row"
                v-for="(item, index) in order.items"
                v-bind:key="item.id"
              >
                <!-- Turf icon -->
                <div class="col-1 d-flex align-items-center">
                  <img
                    v-if="item.grass_id && item.grass && item.grass.thumbnail"
                    :src="item.grass.thumbnail.url"
                    width="100%"
                  />
                </div>

                <!-- Turf type select -->
                <div class="col-5">
                  <el-select
                    filterable
                    size="large"
                    v-model="item.grass_id"
                    class="w-100"
                    :class="[
                      {
                        'is-invalid': form.errors.has(
                          `items.${index}.grass_id`
                        ),
                      },
                      'w-100',
                    ]"
                    @change="
                      onSuggestRate(item);
                      calculateLayingPrice();
                      form.errors.clear(`items.${index}.grass_id`);
                    "
                  >
                    <el-option
                      v-for="itemGrass in grasses"
                      :key="itemGrass.id"
                      :label="itemGrass.full_name"
                      :value="itemGrass.id"
                    ></el-option>
                  </el-select>
                  <div class="invalid-feedback">Turf type is required.</div>
                </div>

                <!-- sqm m2 input -->
                <div class="col-2">
                  <el-input-number
                    v-model="item.size_sqm"
                    :controls="false"
                    size="large"
                    class="text-left"
                    :class="[
                      {
                        'is-invalid': form.errors.has(
                          `items.${index}.size_sqm`
                        ),
                      },
                      'w-100',
                    ]"
                    @blur="
                      onSuggestRate(item);
                      onOrderTypeChange();
                      form.errors.clear(`items.${index}.size_sqm`);
                    "
                  >
                  </el-input-number>
                  <div class="invalid-feedback">Quantity is required.</div>
                </div>

                <!-- Price per sqm measure -->
                <div class="col-2 d-flex align-items-center">
                  <p class="mb-0">
                    <strong class="">
                      {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(item.size_sqm_turf_dollar_price))
                      }}
                      / sqm
                    </strong>
                  </p>
                </div>

                <!-- Remove button -->
                <div class="col-2 d-flex align-items-center">
                  <a
                    class="fw-500 text-black-500"
                    href=""
                    @click="removeItem($event, item)"
                    >Remove</a
                  >
                </div>

                <div class="col-12">
                  <hr />
                </div>
              </div>

              <!-- Add item button -->
              <a
                href=""
                class="text-success"
                @click="
                  addItem($event);
                  form.errors.clear('items');
                "
                ><strong>Add</strong> <i class="fal fa-plus-circle"></i
              ></a>

              <div
                class="row d-flex align-items-center justify-content-between mt-4"
              >
                <div class="col-2">
                  <p class="mb-2 font-18">Subtotal</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-2 font-18">
                    {{
                      new Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                      }).format(
                        Number(
                          reduceArray(
                            this.order.items,
                            "size_sqm_turf_dollar_price"
                          )
                        )
                      )
                    }}
                  </p>
                </div>
              </div>
              <div
                class="row d-flex align-items-center justify-content-between"
                v-if="order.order_type_id == 2"
              >
                <div class="col-2">
                  <p class="mb-2 font-18">Laying</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-2 font-18">
                    {{
                      new Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                      }).format(Number(order.laying_dollar_price))
                    }}
                  </p>
                </div>
              </div>
              <div
                class="row d-flex align-items-center justify-content-between"
                v-if="[1, 2].includes(order.order_type_id)"
              >
                <div class="col-2">
                  <p class="mb-2 font-18">Delivery</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-2 font-18">
                    {{
                      new Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                      }).format(Number(order.freight_dollar_price))
                    }}
                  </p>
                </div>
              </div>
              <div
                class="row d-flex align-items-center justify-content-between"
              >
                <div class="col-2">
                  <p class="mb-2 font-18">GST</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-2 font-18">
                    {{
                      new Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                      }).format(Number(gstOrder))
                    }}
                  </p>
                </div>
              </div>
              <div
                class="row d-flex align-items-center justify-content-between"
              >
                <div class="col-2">
                  <p class="font-22"><strong>Total</strong></p>
                </div>
                <div class="col-2 text-right">
                  <p class="font-22">
                    <strong>
                      {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(totalOrder))
                      }}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Order from "../../models/customer/Order";
import Item from "../../models/customer/Item";
import Form from "form-backend-validation";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import VueTelInput from "vue-tel-input";
import moment from "moment";
export default {
  components: { VueGoogleAutocomplete, VueTelInput },
  props: {
    customer: {
      type: Object,
    },
    initial_order: {
      type: Object,
      default: function () {
        return {
          order_status_id: 3,
          submitted_at: moment().format("YYYY-MM-DD 00:00:00"),
          address: "",
          locked: false,
          user_id: this.customer.user_id,
          segment_id: this.customer.segment_id,
          override_freight: false,
          override_laying: false,
          laying_dollar_price: 0,
          freight_dollar_price: 0,
          freight_price: 0,
          laying_price: 0,
          market_channel_id: "",
          items: [],
          care_items: [],
          site_contact_name: "",
          site_contact_phone: "",
          extra_attributes: {
            address: { unit: "", longitude: "", latitude: "" },
            billing_address: { unit: "", longitude: "", latitude: "" },
          },
          pallet_type_id: "",
          is_flagged: false,
          is_on_hold: false,
          post_code: null,
          state: null,
          suburb: null,
          freight_rate_id: null,
          pick_up_at: null,
          delivery_notes: "",
          freight_type_id: 1,
        };
      },
    },
    orderTypes: {
      type: Array,
    },
    grasses: {
      type: Array,
    },
    segments: {
      type: Array,
    },
    freightRates: {
      type: Array,
    },
    userRates: {
      type: Array,
    },
    turfCareUserRates: {
      type: Array,
    },
    freightUserRates: {
      type: Array,
    },
  },
  data() {
    return {
      order: new Order(this.initial_order),
      form: new Form(),
      validated: true,
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      delivery: true,
      website_url: process.env.MIX_WEBSITE_URL,
      removedItems: [],
      countdown: null,
      mapFields: [
        "address_components",
        "adr_address",
        "alt_id",
        "formatted_address",
        "geometry",
        "icon",
        /*'id',*/ "name",
        "business_status",
        "photo",
        "place_id",
        "scope",
        "type",
        "url",
        "utc_offset_minutes",
        "vicinity",
      ],
    };
  },
  created() {
    setInterval(() => this.updateCountdown(), 1000);
  },
  computed: {
    limit_edit_date() {
      return moment(this.order.delivery_date)
        .set({
          hour: 7,
          minute: 0,
          second: 0,
        })
        .subtract(1, "day")
        .format("YYYY-MM-DD hh:mm a");
    },
    edit_order() {
      return moment(moment(this.limit_edit_date)).diff(moment()) >= 0;
    },
    gstOrder() {
      if (this.order.items.length || this.order.care_items.length) {
        return (
          Number(
            this.reduceArray(this.order.items, "size_sqm_turf_dollar_price") +
              this.order.freight_dollar_price +
              this.order.laying_dollar_price
          ) / 10
        ).toFixed(2);
      }

      return 0;
    },
    totalOrder() {
      return (
        Number(this.order.freight_dollar_price) +
        Number(this.order.laying_dollar_price) +
        Number(
          this.reduceArray(this.order.items, "size_sqm_turf_dollar_price")
        ) +
        Number(this.gstOrder)
      );
    },
  },
  methods: {
    updateCountdown() {
      let countdown = moment.duration(
        moment(this.limit_edit_date).diff(moment(new Date()))
      );
      if (countdown.asHours() < 24 && countdown.asHours() > 0)
        this.countdown = [
          Math.ceil(countdown.asHours()) + "h",
          countdown.minutes() + "m",
          countdown.seconds() + "s",
        ].join(" ");
      else this.countdown = null;
    },
    disabledDate(date) {
      return date < moment().add(2, "days") || moment(date).day() == 0;
    },
    getAddressData: function (addressData, placeResultData, id) {
      if (this.order.extra_attributes.address.unit_number) {
        addressData.unit_number =
          this.order.extra_attributes.address.unit_number;
      }
      this.order.extra_attributes.address = addressData;
      this.order.suburb = addressData.locality;
      this.order.state = addressData.administrative_area_level_1;
      this.order.post_code = addressData.postal_code;
      this.checkDeliveryPostalCode();
      this.calculateDeliveryPrice();
    },
    onNumberValidate(validated_information) {
      this.validated = validated_information.isValid;
    },
    reduceArray(object, key) {
      if (object) {
        return object.reduce(function (accumulator, currentValue) {
          return accumulator + parseFloat(currentValue[key]);
        }, 0);
      } else {
        return 0;
      }
    },
    calculateDeliveryPrice() {
      this.order.freight_dollar_price = 0;
      if ([1, 2].includes(this.order.order_type_id)) {
        let freight = this.freightRates.find((rate) =>
          rate.postcodes.includes(this.order.post_code)
        );

        if (freight) {
          let size_sqm = this.reduceArray(this.order.items, "size_sqm");

          let userRate = this.freightUserRates.find(
            (x) => x.freight_rate_id == freight.id
          );

          if (
            this.customer.is_special_price &&
            userRate &&
            (userRate.rate || userRate.flat_rate)
          ) {
            let rate_value = userRate.dollar_rate;
            let flat_rate = userRate.dollar_flat_rate;

            if (size_sqm <= userRate.flat_rate_sqm)
              this.order.freight_dollar_price = flat_rate;
            else this.order.freight_dollar_price = size_sqm * rate_value;

            this.order.freight = freight;
            this.order.freight_rate_id = freight.id;
          } else if (freight.segments) {
            let segment = freight.segments.find(
              (s) => s.id == this.order.segment_id
            );
            if (segment) {
              if (size_sqm <= segment.pivot.flat_rate_sqm)
                this.order.freight_dollar_price = segment.pivot.flat_rate;
              else
                this.order.freight_dollar_price =
                  size_sqm * segment.pivot.sqm_rate;

              this.order.freight = freight;
              this.order.freight_rate_id = freight.id;
            }
          }
        }
      }
    },
    calculateLayingPrice() {
      this.order.laying_dollar_price = 0;
      if (this.order.segment_id && this.order.order_type_id == 2) {
        let segment = this.segments.find((x) => x.id == this.order.segment_id);

        if (segment) {
          let size_sqm = this.reduceArray(this.order.items, "size_sqm");

          if (size_sqm <= segment.laying_min_sqm_qty) {
            this.order.laying_dollar_price = segment.dollar_laying_price;
          } else
            this.order.laying_dollar_price =
              size_sqm * segment.dollar_laying_rate;
        }
      }

      this.order.items.forEach((element) => {
        this.onSuggestRate(element);
      });
    },
    onOrderTypeChange() {
      this.calculateDeliveryPrice();
      this.calculateLayingPrice();
    },
    onSuggestRate(item) {
      if (this.order.segment_id && item.grass_id) {
        let segment = this.segments.find((x) => x.id == this.order.segment_id);
        let grass = this.grasses.find((x) => x.id == item.grass_id);

        let userRate = this.userRates.find((x) => x.grass_id == item.grass_id);

        if (grass.rate) {
          if (this.customer.is_special_price && userRate && userRate.rate) {
            let rate_value = userRate.dollar_rate;
            this.$set(item, "rate_dollar_price", rate_value);
            this.$set(item, "rate_price", rate_value);
          } else {
            let price = grass.dollar_rate;

            if (segment) {
              price = (grass.dollar_rate * (100 - segment.discount)) / 100;

              if (segment.grass_rates.length > 0) {
                let grass_rate = segment.grass_rates.find(
                  (x) => x.grass_id == grass.id
                );

                if (grass_rate && grass_rate.discount > 0) {
                  if (grass_rate.is_fixed) {
                    price = grass.dollar_rate - grass_rate.discount;
                  } else {
                    price =
                      (grass.dollar_rate * (100 - grass_rate.discount)) / 100;
                  }
                }
              }
            }

            this.$set(item, "rate_dollar_price", Number(price).toFixed(2));
            this.$set(item, "rate_price", price);
          }

          this.$set(item, "grass", grass);

          this.setPricingSummary(item);
        } else {
          this.$message({
            type: "info",
            message: `Rate could not be auto set - please confirm all order information is filled out`,
          });
        }
      }
    },
    setPricingSummary(item) {
      let segment = this.segments.find((x) => x.id == this.order.segment_id);
      let grass = this.grasses.find((x) => x.id == item.grass_id);
      item.size_sqm_turf_dollar_price = Number(
        Number(item.rate_dollar_price) * Number(item.size_sqm)
      ).toFixed(2);

      if (this.order.order_type_id == 2) {
        let laying_price =
          Number(item.size_sqm) < Number(grass.laying_min_sqm)
            ? Number(grass.laying_min_sqm) * Number(grass.laying_rate)
            : Number(item.size_sqm) * Number(grass.laying_rate);

        item.size_sqm_laying_dollar_price = Number(laying_price).toFixed(2);
      } else {
        item.size_sqm_laying_dollar_price = 0;
      }

      item.number_of_pallets = Math.ceil(
        Number(item.size_sqm) / Number(grass.pallets_per_sqm)
      );
    },
    checkDeliveryPostalCode() {
      let rate = this.freightRates.find((rate) =>
        rate.postcodes.includes(this.order.post_code)
      );
      if (rate) {
        this.delivery = true;
      } else {
        this.delivery = false;
      }
    },
    addItem(event) {
      event.preventDefault();
      this.order.items.push({
        grass_id: null,
        size_sqm: 0,
        rate_dollar_price: 0,
        rate_price: 0,
        size_sqm_turf_dollar_price: 0,
        size_sqm_laying_dollar_price: 0,
        grass: null,
        number_of_pallets: 0,
      });
    },
    removeItem(event, item) {
      event.preventDefault();
      this.$confirm("You are about to remove this item. Continue?", "Warning", {
        confirmButtonText: "OK",
        confirmButtonClass: "primary-btn",
        cancelButtonText: "Cancel",
        cancelButtonClass: "secondary-btn",
        type: "warning",
      }).then(() => {
        if (item.id) {
          this.removedItems.push(item.id);
        }

        let index = this.order.items.indexOf(item);
        this.order.items.splice(index, 1);
        this.calculateLayingPrice();
      });
    },
    cancelOrder(event) {
      event.preventDefault();
      this.$confirm(
        "You are about to cancel this order. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          confirmButtonClass: "primary-btn",
          cancelButtonText: "Cancel",
          cancelButtonClass: "secondary-btn",
          type: "warning",
        }
      ).then(() => {
        if (this.order.id) {
          this.order.order_status_id = 2;
          this.order.save().then((res) => {
            this.$message({
              type: "success",
              message: "Order cancelled",
            });
            window.location.href = `/orders/${this.order.id}`;
          });
        } else {
          window.location.href = `/orders`;
        }
      });
    },
    onSubmit() {
      if (!this.edit_order && this.order.id) {
        this.$message({
          type: "info",
          message:
            "We are processing your order. Please contact us to change this order",
        });
        return;
      }

      _.forEach(this.order.items, (item) => {
        item.size_sqm_laying_price =
          item.size_sqm_laying_dollar_price * this.$PRICE_CONVERSION_FACTOR;
        item.size_sqm_turf_price =
          item.size_sqm_turf_dollar_price * this.$PRICE_CONVERSION_FACTOR;
        item.rate_price =
          item.rate_dollar_price * this.$PRICE_CONVERSION_FACTOR;
      });

      _.forEach(this.removedItems, (item_id) => {
        new Item({ id: item_id }).delete();
      });

      this.order.laying_price =
        this.order.laying_dollar_price * this.$PRICE_CONVERSION_FACTOR;
      this.order.freight_price =
        this.order.freight_dollar_price * this.$PRICE_CONVERSION_FACTOR;
      this.order
        .save()
        .then((res) => {
          this.$message({
            type: "success",
            message: "Saved",
          });
          if (!this.order.id) {
            var url = window.location.toString();
            url = url.replace("create", `${res.id}/edit`);
            window.history.pushState(null, null, url);
          }

          this.order = res;
        })
        .catch((errors) => {
          this.form.errors.record(errors.response.data.errors);
        });
    },
  },
};
</script>
